import { FunctionOutlined } from '@ant-design/icons';
import {
  type IRichTextButtonProps,
  RichTextButton,
} from '@framework/form/inputs/rich-text/menu/RichTextMenuButton.tsx';
import {
  type IDropdownClickInfo,
  SearchableDropdown,
} from '@framework/ui/components/dropdown/SearchableDropdown.tsx';
import { type Editor } from '@tiptap/react';
import { Typography } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { ComputeMathAllFunctions } from '../../ComputeMath.ts';

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding: 4px 0;
  /* padding-top: 4px;
  padding-bottom: 5px; */
  .ant-typography {
    line-height: 1.3;
    font-weight: normal;
    strong {
      font-size: 1.1em;
    }
  }
`;

const FunctionSignature = styled.div`
  font-size: 0.82em;
`;

export interface IComputeMathFunctionRichTextButtonProps {
  editor: Editor | null;
  onlyIcon?: boolean;
  buttonProps?: IRichTextButtonProps;
}

/**
 * Permette di selezionare una funzione matematica da inserire nell'espressione.
 */
export function ComputeMathFunctionRichTextButton(
  props: IComputeMathFunctionRichTextButtonProps,
) {
  const { editor, onlyIcon, buttonProps } = props;

  const items = React.useCallback((search?: string) => {
    return ComputeMathAllFunctions.filter(
      f =>
        !search ||
        f.name.toLowerCase().includes(search.toLowerCase()) ||
        f.description.toLowerCase().includes(search.toLowerCase()),
    ).map(f => ({
      key: f.name,
      label: (
        <OptionWrapper>
          <Typography.Text strong>{f.name}</Typography.Text>
          {f.signature && (
            <FunctionSignature>
              <code>{f.signature}</code>
            </FunctionSignature>
          )}
          <Typography.Text>{f.description}</Typography.Text>
        </OptionWrapper>
      ),
    }));
  }, []);

  const handleInsertFunction = React.useCallback(
    ({ key }: IDropdownClickInfo) => {
      const fun = ComputeMathAllFunctions.find(r => r.name === key)!;
      editor!
        .chain()
        .focus()
        .insertContent([
          {
            type: 'text',
            text: fun.name + '()',
          },
        ])
        .run();
    },
    [editor],
  );

  if (!editor) return null;

  return (
    <SearchableDropdown items={items} onClick={handleInsertFunction}>
      <RichTextButton
        {...buttonProps}
        onClick={e => e.preventDefault()}
        icon={<FunctionOutlined />}
        title="Chiamata a Funzione"
        disabled={!editor.isEditable}
      >
        {onlyIcon ? undefined : 'Funzione'}
      </RichTextButton>
    </SearchableDropdown>
  );
}
